export default function ShieldCheckIcon({ fillColor = 'var(--color-text-dark)' }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
            <path
                d="M12 0a2 2 0 0 0-.78.16L3.9 3.3A3 3 0 0 0 2 6.08v5.2c0 6.06 4.07 9.84 9.3 12.5a1.55 1.55 0 0 0 1.4 0C17.93 21.12 22 17.34 22 11.28v-5.2a3 3 0 0 0-1.9-2.78L12.78.16A2 2 0 0 0 12 0Zm0 2 7.34 3.15a1 1 0 0 1 .66.93v5.2c0 5.02-3.3 8.25-8 10.66-4.7-2.41-8-5.64-8-10.66v-5.2a1 1 0 0 1 .66-.93L12 2Z"
                fill={fillColor} />
            <path
                d="m10.7 14.2-2.2-2.2a1 1 0 0 0-1.4 1.42l2.9 2.9a1 1 0 0 0 1.42 0l5-5a1 1 0 0 0-1.42-1.42l-4.3 4.3Z"
                fill={fillColor} transform="translate(0, -1)"/>
        </svg>
    )
}
